import { useMutation, useQuery } from '@tanstack/react-query';

import { CountryList, MessageWithText } from '@services/types';

import { downloadChatHistory, getImprovedPrompt, getSupportedCountries } from './api';
import { ImprovedPromptResponse, PromptToImprovePayload } from './types';

const queryKeys = {
    supportedCountries: 'supportedCountries',
} as const;

export const useImprovePrompt = () =>
    useMutation<ImprovedPromptResponse, Error, PromptToImprovePayload>({
        mutationFn: getImprovedPrompt,
    });

const chatHistoryFileName = 'chat_history.docx';

export const useDownloadChatHistory = () =>
    useMutation<Blob, Error, Array<MessageWithText>>({
        mutationFn: downloadChatHistory,
        onSuccess: (blob) => {
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = chatHistoryFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        },
    });

export const useSupportedCountries = () =>
    useQuery<CountryList, Error>({
        queryKey: [queryKeys.supportedCountries],
        queryFn: getSupportedCountries,
    });
